<template>
  <MetaTags v-if="metaInfo" :meta-info="metaInfo" />
  <div class="static-content cookie-consent-page">
    <main class="content__main content__main--column">
      <article class="article article--cookie-settings-page">
        <h1 class="article__title">Evästeet ja verkkotunnisteiden käyttö</h1>
        <p class="article__lead">Käytämme OP Ryhmän verkkosivustoilla ja sovelluksissa erilaisia evästeitä, yksilöiviä
          tunnisteita ja analytiikkaratkaisuja. </p>
        <p class="article__lead">Osa evästeistä on sivustojemme luotettavan ja turvallisen toiminnan kannalta
          välttämättömiä. Muilta osin voit valita, mitä tietoja saamme kerätä ja mihin käyttötarkoituksiin voimme
          tietoja käyttää. Emme esimerkiksi hyödynnä tietoja kohdentamisessa ja markkinoinnissa ilman suostumustasi.</p>
        <p class="article__lead">Evästeasetuksesi tallentuvat selaimeesi.</p>
        <p class="article__lead">Kerromme tällä sivulla myös, miten evästeet toimivat, mitä työkaluja käytämme ja miten
          yksityisyytesi on suojattu.</p>

        <div class="article__content article__content--extended content-block-container">
          <h2 class="article__title-thin">Omat evästeasetuksesi</h2>

          <div class="article__selection-container">
            <label class="container" :class="{ 'disabled-checkbox': hoverDisabledCheckbox }"
              @mouseover="hoverDisabledCheckbox = true" @mouseleave="hoverDisabledCheckbox = false"
              for="requiredConsent">
              Välttämättömät evästeet
              <input type="checkbox" tabindex="1" id="requiredConsent" value="on"  :checked="chosenConsents[consentChoices.mandatory.position]"
                disabled checked />
              <span class="checkmark"></span>
            </label>

            <p>Välttämättömien evästeiden avulla varmistamme sivustojemme ja palvelujemme luotettavan toiminnan ja
              turvallisen asioinnin sekä torjumme väärinkäytöksiä. Niiden avulla voit esimerkiksi kirjautua palveluun ja
              kieliasetukset toimivat oikein. Välttämättömien evästeiden käytön voit estää ainoastaan selaimesi
              asetuksissa.</p>
            <p>Emme luovuta näitä tietoja OP Ryhmän ulkopuolelle.</p>
          </div>

          <div class="article__selection-container">
            <label class="container" for="developmentConsent">
              Toiminnan kehittämisevästeet
              <input type="checkbox" tabindex="2" id="developmentConsent" value="on"
                :checked="chosenConsents[consentChoices.development.position]" 
                @change="chosenConsents[consentChoices.development.position] = $event.target.checked ? 1 : 0"
                @keydown.enter.prevent="handleEnterKey($event, 'development')"/>
              <span class="checkmark"></span>
            </label>

            <p>Käytämme toiminnan kehittämisevästeillä kerättyjä tietoja uusien palvelujen ja liiketoiminnan
              kehittämiseen OP Ryhmän sisällä. Saamme palvelun käytöstä myös tilastotietoa, jota käytämme palvelun ja
              liiketoiminnan raportointiin. Seuraamme toiminnan kehittämisevästeillä keräämiemme tietojen avulla muun
              muassa kävijöiden aktiivisuutta ja käyttäytymistä eri verkko- ja mobiilipalveluissamme.</p>
            <p>Käyttäytymistiedon perusteella luomme erilaisia käyttäjäluokituksia ja -mallinnuksia sekä kehitämme
              yksilöllistä käyttäjäkokemusta eri palvelukanavissa.</p>
            <p>Luovutamme kumppanillemme Adobelle selaimesi ja päätelaitteesi teknisiä tietoja, joita Adobe käyttää
              OP:lle tarjoamansa analytiikkapalvelun kehittämiseen ja anonyymiin raportointiin. Adobe ei voi yhdistää
              näitä tietoja asiakkuuteesi.</p>
          </div>

          <div class="article__selection-container">
            <label class="container" for="targetingConsent">
              Kohdentamisevästeet
              <input type="checkbox" tabindex="3" id="targetingConsent" value="on" :checked="chosenConsents[consentChoices.targeting.position]" 
              @change="chosenConsents[consentChoices.targeting.position] = $event.target.checked ? 1 : 0"
              @keydown.enter.prevent="handleEnterKey($event, 'targeting')"/>
              <span class="checkmark"></span>
            </label>

            <p>Kohdentamisevästeiden avulla saat sinua kiinnostavaa sisältöä kaikille suunnatun sisällön sijaan OP
              Ryhmän omissa ja yhteistyökumppaniemme palveluissa. </p>
            <p>Voimme tarjota mielenkiinnon kohteitasi vastaavaa sisältöä esimerkiksi sen perusteella, millä OP:n
              sivustoilla olet käynyt tai mitä sisältöjä olet katsonut. Voit nähdä OP:n mainoksia myös OP:n
              yhteistyökumppanien verkkosivustoilla meidän pyynnöstämme. </p>
            <p>Emme luovuta kohderyhmiä tai asiakastietoja OP Ryhmän ulkopuolelle. Voimme kuitenkin luovuttaa
              kumppanillemme Adformille selaimesi yksilöivän evästepohjaisen tunnisteen, jota kumppanimme käyttää OP:n
              mainosten kohdentamiseen sekä kohdentamispalvelun kehittämiseen. Evästetunnistetietoa ei voida yhdistää
              asiakkuuteesi.</p>
          </div>

          <div class="article__selection-container">
            <label class="container" for="externalConsent">
              Kohdentamisen evästeet ja kolmannen osapuolen markkinointievästeet
              <input type="checkbox" tabindex="4" id="externalConsent" value="on" :checked="chosenConsents[consentChoices.marketing.position]" 
              @change="chosenConsents[consentChoices.marketing.position] = $event.target.checked ? 1 : 0"
              @keydown.enter.prevent="handleEnterKey($event, 'marketing')"/>
              <span class="checkmark"></span>
            </label>

            <p>Kolmannen osapuolen markkinointievästeiden avulla voimme kohdentaa sinulle OP:n ajankohtaista
              markkinointia eri verkkosivustoilla ja yhteisöpalveluissa. Niiden avulla saamme myös tilastotietoa
              markkinoinnista ja kohderyhmistä.</p>
            <p>Mainosverkostoomme kuuluvat sosiaalisen median palvelut (Facebook, Instagram, LinkedIn, Twitter ja
              YouTube) voivat hyödyntää markkinointievästeillä kerättyjä tietoja myös omassa käytössään. Tietoja voidaan
              siten luovuttaa OP Ryhmän ulkopuolelle kolmansien osapuolten käyttöön.</p>
          </div>
          <div :class="{ 'hidden': !isConsentSaved }" :aria-hidden="!isConsentSaved"
            class="cookie-settings__alert cookie-settings__alert--success" role="status">
            <i aria-label="OK" class="icon icon-check cookie-settings__alert-icon" role="img"></i>
            <div class="cookie-settings__alert-body">Tallennus onnistui.</div>
          </div>
          <div>
            <button tabindex="5" class="form-button primary" type="button" @click="setConsent()">
              <span>Tallenna valinnat</span>
            </button>
          </div>
          <div class="content-block-container">
            <h2>Evästeiden estäminen</h2>

            <p class="title">Evästehistorian poistaminen</p>
            <p>Voit tyhjentää selaimesi asetuksista evästehistorian, jolloin selaimesi tallentamat aikaisemmat evästeet
              poistuvat. Evästehistorian poistaminen ei estä uusien evästetietojen muodostumista, vaan sinun on
              peruttava evästesuostumus OP:n sivuilla. </p>

            <p class="title">Aikaisempien kohdentamistietojen käytön estäminen</p>
            <p>Jos olet aikaisemmin sallinut kohdentamisevästeet, uudet evästeasetuksesi eivät heti poista vanhoja
              evästetietoja. Saatat nähdä kohdennettua markkinointia yhteistyökumppaniemme sivustoilla vielä 60 päivän
              ajan suostumuksen perumisesta.</p>

            <p class="title">Kolmansien osapuolten verkkomainonnan estäminen</p>
            <p>Jos et ole aikaisemmin estänyt kolmansien osapuolten evästeitä, mainostajat ja mainosverkostot
              kohdentavat mainontaa sinulle OP Ryhmän sivuilta aiemmin kerätyn selainpohjaisen käyttäytymistiedon
              perusteella.</p>
            <p>Voit estää aikaisemmin luovutettujen tietojen perusteella näytettävän OP:n ulkopuolisen verkkomainonnan
              kokonaan tai yrityskohtaisesti.</p>
            <p>
              <action-link
                to="https://www.op.fi/c/portal/linkki?url=https://www.youronlinechoices.com/fi/omat-mainokset&t=1697120381799"
                >
                Estä kohdennettu verkkomainonta Your Online Choices -sivustolla
                </action-link>
            </p>

            <p class="title">Kaikkien evästeiden estäminen</p>
            <p>Jos haluat estää evästeiden käytön kokonaan, voit tehdä sen muuttamalla selaimesi asetuksia. Tarkemmat
              ohjeet löydät käytössäsi olevan selaimen ohjeista.</p>
            <p>Jos estät kaikki evästeet käyttäen evästeiden esto-ohjelmia tai selaimesi asetuksia, emme voi taata
              palvelujen perustoimintojen, kuten kieliasetusten ja kirjautumisen, toimivuutta.</p>

            <div class="content-block-container">
              <h2>Miten evästeet toimivat?</h2>

              <p>Evästeet ovat pieniä tekstitiedostoja, jotka tallentuvat laitteesi selaimeen. Ne kertovat meille
                esimerkiksi minkälaisella laitteella käytät verkkopalvelua ja oletko vieraillut sivustoillamme
                aikaisemmin.</p>
              <p>Jos käytät eri selaimia, niissä voi olla eri evästeasetukset. Jos samaa laitetta ja selainta käyttää
                useampi henkilö, yhden käyttäjän tekemät evästevalinnat koskevat myös muita käyttäjiä, ellei evästeitä
                poisteta selaimesta käytön jälkeen.</p>
              <p>Jos olet sallinut vain välttämättömät evästeet, kysymme suostumustasi uudelleen 6 kuukauden kuluttua.
                Muut evästeasetuksesi ovat voimassa 12 kuukautta.</p>
              <p>Jos poistat evästeet selaimesta, kysymme suostumustasi uudelleen, kun vierailet verkkosivustollamme
                seuraavan kerran.</p>
            </div>

            <div class="content-block-container">
              <h2>Mitä työkaluja käytämme ja kuinka kauan tietoja säilytetään?</h2>

              <p>Käytämme sekä istuntokohtaisia että pysyviä evästeitä:</p>
              <p><strong>Istuntokohtaiset evästeet</strong> ovat olemassa vain yhden istunnon eli asiointikerran ajan.
                Ne poistetaan automaattisesti, kun suljet selaimen. Istuntoevästeiden avulla pystyt esimerkiksi
                liikkumaan sivulta toiselle, kirjautumaan palveluun ja käyttämään erilaisia laskureita ja
                verkkolomakkeita.</p>
              <p><strong>Pysyvät evästeet</strong> jäävät selaimeesi tai laitteellesi myös istunnon loppumisen jälkeen
                määräajaksi, jos et poista niitä sitä ennen selaimesi asetuksista. Pysyvien evästeiden avulla parannamme
                käyttökokemusta. Niiden avulla sivusto tunnistaa laitteesi ja muistaa asetuksesi, esimerkiksi
                kielivalintasi, kun vierailet sivustolla uudelleen.</p>

              <h2>Työkalulistaus</h2>
              <p>Kerromme jokaisen työkalun kohdalla evästeiden enimmäissäilytysajan.</p>
              <table border="1">
                <thead>
                  <tr>
                    <th>
                      <strong>Työkalun nimi</strong>
                    </th>
                    <th>
                      <strong>Säilytysaika enintään</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <p><strong>Välttämättömät evästeet</strong></p>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <p><strong>Giosk Live Chat</strong><br />Giosg Live Chat -palvelun evästeiden avulla tarjoamme
                        chat-palvelua sekä analysoimme ja kehitämme palvelua.</p>
                    </td>
                    <td>
                      <p>2 vuotta</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p><strong>Toiminnan kehittämisevästeet</strong></p>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <p><strong>Adobe Analytics</strong><br />Analysoimme Adobe Analyticsin avulla kävijöiden
                        aktiivisuutta, käyttäytymistä, virhetilanteita, käyttömääriä ja liikennettä OP:n omilla
                        verkkosivustoilla ja mobiilisovelluksissa. Käytämme näitä tietoja uusien palvelujen ja
                        liiketoiminnan kehittämiseen OP Ryhmän sisällä.</p>
                    </td>
                    <td>
                      <p>2 vuotta</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p><strong>Kohdentamisevästeet</strong></p>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <p><strong>Adform</strong><br />Käytämme joillakin verkkosivustollamme myös Adformin pikseleitä.
                        Niillä voimme analysoida ja tilastoida sivustoliikennettä sekä kohdentaa mainontaa.</p>
                    </td>
                    <td>
                      <p>13 kuukautta</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="content-block-container">
              <h2>Kolmannen osapuolen markkinointievästeet</h2>

              <p>Kolmannen osapuolen (Facebook, Instagram, LinkedIn, Twitter ja YouTube) markkinointievästeiden avulla
                voimme kohdentaa käyttäjälle OP:n ajankohtaista markkinointia eri verkkosivustoilla ja
                yhteisöpalveluissa. Niiden avulla saamme myös tilastotietoa markkinoinnista ja kohderyhmistä.</p>
              <p>Markkinointievästeiden säilytysajoista vastaavat kolmannet osapuolet omien tietosuojakäytäntöjensä
                mukaisesti.</p>

              <h2>Yhteisöliitännäiset</h2>

              <p>Käytämme OP Ryhmän verkkosivustoilla sosiaalisia laajennuksia eli kolmannen osapuolen
                yhteisöliitännäisiä. Niiden avulla voit nähdä sivustoilla esimerkiksi Facebookin, Instagramin,
                LinkedInin, SoundCloudin, Twitterin ja YouTuben sisältöjä.</p>
              <p>Yhteisöliitännäiset latautuvat sosiaalisen median palveluntarjoajien omilta palvelimilta.
                <strong>Evästevalintasi eivät toistaiseksi vaikuta yhteisöliitännäisten evästekäytäntöihin.</strong>
                Liitännäiset voivat asettaa omia evästeitä omien periaatteidensa mukaisesti ja kerätä evästeiden avulla
                tietoa käyttäjistä.</p>

              <h2>Yksityisyytesi on meille tärkeä</h2>
              <p>Evästeillä ja eri työkaluilla kerätyt tiedot ovat OP Ryhmän rekisterinpitäjien omistuksessa.
                Kumppanimme toimivat lähtökohtaisesti tietojen käsittelijöinä OP:n puolesta ja lukuun.</p>
              <p>Kohdentamisevästeiden suostumuksella asetettavan evästeen käytössä OP kuitenkin toimii
                yhteisrekisterinpitäjänä palveluntarjoajansa Adformin (linkki Adformin tietosuojaselosteeseen) kanssa
                ID-tiedon osalta. ID-tieto on satunnaisesti luotu numerosarja, jolla OP voi muistaa yksittäisen
                sivuillaan käyneen verkkoselaimen ja lähettää mainontaa näytettäväksi tuossa selaimessa myös muilla
                verkkosivuilla, jotka myyvät OP:lle mainostilaa. Adform-kohdentamiseväste on käytössä tietyillä
                op.fi-sivuston alasivuilla, joista osa on näkyvissä vain kirjautuneelle käyttäjälle.
                Kohdentamisevästettä ei milloinkaan käytetä op.fi-sivuston sivuilla, joilla näytetään maksutietoja,
                tilitietoja tai vakuutustietoja. Kohdentamisevästeen ID-tietoa ei yhdistetä asiakastietoihisi OP
                Ryhmässä.</p>
              <p>ID-tieto luovutetaan Adformille, joka käyttää tietoa tarjotakseen OP:lle verkkomarkkinoinnin
                kohdentamisen palvelua sekä kehittääkseen tätä palvelua. Adform ei voi yhdistää ID-tietoa sinuun.
                Kohdentamispalvelun lisäksi Adform käyttää ID-tietoja itsenäisenä rekisterinpitäjänä aggregoidussa, eli
                yhdistellyssä, muodossa petosten estämiseen ja tilastointiin. Markkinoinnin kohdentamiseen ei käytetä,
                eikä Adformille lähetetä, OP Ryhmän asiakuuteen liittyviä tietojasi, kuten tietoja pankki- tai
                vakuutusasioinnista.</p>
              <p>Markkinointievästeiden suostumuksella voimme luovuttaa tietoja kolmansille osapuolille. Näiden tietojen
                käytöstä vastaavat kolmannet osapuolet yhteisrekisterinpitäjinä OP:n kanssa tai itsenäisinä
                rekisterinpitäjinä omien tietosuojakäytäntöjensä mukaisesti.</p>
              <p>Verkkoanalytiikkaa keräämme ja hyödynnämme ainoastaan kehittämisevästeiden suostumuksella.
                Digipalveluidemme verkkoanalytiikkaa käsittelee OP:n palveluntarjoaja Adobe. Seuraamme Adobe Analytics
                -työkalun avulla, että digitaaliset palvelumme toimivat oikein ja virheettömästi ja vastaavat
                asiakkaidemme tarpeisiin. Analysoimme esimerkiksi virhetilanteita, käyttömääriä ja liikennettä OP:n
                omilla verkkosivustoilla ja mobiilisovelluksissa. Varmistamme verkkoanalytiikan kehityksessämme, että
                yksityisyyden suoja toteutuu.</p>
              <p>Adobe tarjoaa Adobe Analytics –työkalun OP:lle henkilötietojen käsittelijän roolissa. Adobe käyttää
                myös itsenäisen rekisterinpitäjän roolissa Adobe Analytics -evästeillä kerättyjä teknisiä tietoja
                (IP-osoite, selaimen ja laitteen tyyppi, asetukset, eväste-ID, versio, kieliasetukset) tuotteidensa
                testaamiseen ja kehittämiseen. Nämä tiedot ovat pseudonyymeja henkilötietoja, mutta Adobe ei tunnista
                yksittäisiä OP:n sivustojen käyttäjiä vaan käyttää dataa massamuodossa. Adobe myös luo täysin anonyymeja
                raportteja yritysasiakkaidensa, kuten OP:n, Adobe-työkaluilla keräämästä datasta. Voit kieltää Adoben
                evästetietojen käytön seuraavan linkin takaa, kohdasta Adobe Experience Cloud: <a
                  href="https://www.adobe.com/fi/privacy/opt-out.html" target="_blank">Adoben tietosuojakeskus.</a></p>
              <p>Vastuullisena toimijana olemme sitoutuneet suojelemaan yksityisyyttäsi tietosuojalainsäädännön
                mukaisesti. <a href="https://www.op.fi/tietosuoja/henkilotieto" target="_blank">Lue lisää
                  henkilötietojen käsittelystä OP:lla</a></p>

              <p>Tutustu kumppaniemme ja sosiaalisen median palvelujen omiin tietosuojakäytäntöihin:</p>

              <ul>
                <li v-for="cookieLink in cookieLinkList">
                  <a :href="cookieLink.linkURL" target="_blank" rel="noopener noreferrer"
                    class="action-link">{{ cookieLink.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </article>
    </main>
  </div>
</template>

<script>
import isSSR from '@/utils/isSSR';
import MetaTags from '@/app/components/MetaTags.vue';
import logger from '@/app/logger';
import config from '@/config';
import ActionLink from '@/app/components/action-link/action-link.vue';

export default {
  name: 'cookies',
  components: {
    MetaTags,
    ActionLink
  },
  data: () => ({
    consentChoices: {
      mandatory: {value: 1, position: 0},
      development: {value: 0, position: 1},
      targeting: {value: 0, position: 2},
      marketing: {value: 0, position: 3},
    },
    chosenConsents: [],
    isConsentSaved: false,
    hoverDisabledCheckbox: false,
    cookieLinkList: [
      { name: 'Adform', linkURL: 'https://site.adform.com/privacy-center/overview' },
      { name: 'Adobe', linkURL: 'https://www.adobe.com/fi/privacy/policy.html' },
      { name: 'Facebook', linkURL: 'https://www.facebook.com/about/privacy/' },
      {
        name: 'Google Ads',
        linkURL: 'https://policies.google.com/privacy?hl=fi'
      },
      { name: 'Instagram', linkURL: 'https://help.instagram.com/155833707900388' },
      { name: 'LinkedIn', linkURL: 'https://www.linkedin.com/legal/privacy-policy' },
      {
        name: 'Salesforce DMP',
        linkURL: 'https://www.salesforce.com/products/marketing-cloud/sfmc/audience-studio-privacy/'
      },
      { name: 'Twitter', linkURL: 'https://twitter.com/en/privacy' },
      { name: 'YouTube', linkURL: 'https://policies.google.com/privacy?hl=fi' }
    ]
  }),
  computed: {
    metaInfo() {
      return {
        meta: [{ name: 'robots', content: 'noindex, follow' }],
        link: [{ rel: 'canonical', href: `${config.FRONT.PROD_BASE_URL}${this.$route.path}` }],
      };
    },
  },
  methods: {
    handleEnterKey(event, pos) {
      const checkbox = event.target;
      checkbox.checked = !checkbox.checked;
      this.chosenConsents[this.consentChoices[pos].position] = checkbox.checked ? 1 : 0;
    },
    waitForOpConsent() {
    const checkInterval = 100; // Check every 100ms
    const maxAttempts = 50; // Maximum number of attempts (5 seconds)

    let attempts = 0;
    const checkOpConsent = () => {
      if (window.opConsent && window.opConsent.getConsent) {
        this.chosenConsents = window.opConsent.getConsent().categories;
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkOpConsent, checkInterval);
      } else {
        logger.error('opConsent script not ready after maximum attempts');
      }
    };

    checkOpConsent();
  },
  setConsent () {
      this.isConsentSaved = true;
      window.opConsent.setConsentArray(this.chosenConsents);
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!isSSR) {
        this.waitForOpConsent();
      }
    });
  },
  watch: {
    chosenConsents: {
      handler: function () {
        this.isConsentSaved = false;
      },
      deep: true
    }
  },
};
</script>
